<template>
    <el-form :model="roleInfo" :rules="roles" ref="roleInfo" class="demo-ruleForm">
        <div class="simple-form">
            <div style="margin-left: 35px;" v-if="isAdd">
                <span>参考平台预制职责权限配置</span>
                <span class="font-blue">
                    <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon font-blue" title="选择平台模版岗位" @click="tplComRoleDlg()">选择</i>
                </span>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">职责权限名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="confName">
                        <el-input v-model="roleInfo.confName" class="width-1-5x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">目标岗位名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="realName">
                        <el-input v-model="roleInfo.realName" class="width-1-5x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">业务范围</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="bizPermScopName">
                        <el-input class="bottom-line width-1-5x" v-model="roleInfo.bizPermScopName" :disabled="true"></el-input>
                        <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择业务范围" @click="bizScopeDlg()"></i>
                    </el-form-item>
                </div>
            </div>

            <template v-if="roleInfo.bizPermScopId != null && roleInfo.bizPermScopId != -1">
                <div class="form-group center">
                    <div class="form-label">
                        <label>业务单元类型</label>
                    </div>
                    <div class="form-value">
                        <span>{{ bizUnitTypeMap[roleInfo.bizUnitType] || '' }}</span>
                    </div>
                </div>
                <!--                <div class="form-group center">-->
                <!--                    <div class="form-label">-->
                <!--                        <label>门店专用</label>-->
                <!--                    </div>-->
                <!--                    <div class="form-value">-->
                <!--                        <span>{{ roleInfo.shopFlag ? '是' : '否' }}</span>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="form-group center" v-if="!roleInfo.shopFlag">-->
                <!--                    <div class="form-label">-->
                <!--                        <label>适用级别</label>-->
                <!--                    </div>-->
                <!--                    <div class="form-value">-->
                <!--                        <div>-->
                <!--                            <span v-if="roleInfo.comLevel1">一级业务单元</span>-->
                <!--                            <span v-if="roleInfo.comLevel2"><span v-if="roleInfo.comLevel1">，</span>二级业务单元</span>-->
                <!--                            <span v-if="roleInfo.comLevel3"><span v-if="roleInfo.comLevel1 || roleInfo.comLevel2">，</span>三级业务单元</span>-->
                <!--                            <span v-if="roleInfo.comLevel4"><span v-if="roleInfo.comLevel1 || roleInfo.comLevel2 || roleInfo.comLevel3">，</span>四级业务单元</span>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="form-group center">-->
                <!--                    <div class="form-label">-->
                <!--                        <label>业务权限限制</label>-->
                <!--                    </div>-->
                <!--                    <div class="form-value">-->
                <!--                        <span>{{ roleInfo.bizPermFlag ? '启用' : '关闭' }}</span>-->
                <!--                    </div>-->
                <!--                </div>-->
                <!--                <div class="form-group center" v-if="roleInfo.bizPermFlag">-->
                <!--                    <div class="form-label">-->
                <!--                        <label>业务权限模式</label>-->
                <!--                    </div>-->
                <!--                    <div class="form-value">-->
                <!--                        <span v-if="roleInfo.bizPermOrgFlag == 1">仅本机构</span>-->
                <!--                        <span v-else-if="roleInfo.bizPermOrgFlag == 3">本机构及以下</span>-->
                <!--                    </div>-->
                <!--                </div>-->
            </template>
            <div class="form-group center">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="desc">
                        <el-input class="width-2x" type="textarea" :rows="2" placeholder="请输入描述" v-model="roleInfo.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'

import retailerApi from '../../api/retailer'

import SwbTplComRoleListSelect from '../comn/TplComRoleListSelect';

Vue.regist(SwbTplComRoleListSelect);

import SwbMerchtBizPermScopeListSelect from './MerchtBizPermScopeListSelect';

Vue.regist(SwbMerchtBizPermScopeListSelect);
//
export default {
    name: 'swb-mercht-tpl-role-save',
    desc: '保存模版岗位',
    props: ['item', 'isAdd'],
    data: function () {
        let validateConfName = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('不可为空'));
            } else if(value.length > 60) {
                callback(new Error('最大长度60'));
            } else {
                callback()
            }
        };
        let validateRealName = function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('不可为空'));
            } else if(value.length > 30) {
                callback(new Error('最大长度30'));
            } else {
                callback()
            }
        };
        let validateDesc = function (rule, value, callback) {
            if(Utils.isNoB(value) || value.length < 250) {
                callback()
            } else {
                callback(new Error('最大长度250'));
            }
        };
        let validateNull = function (rule, value, callback) {
            if(Utils.isNoB(value) || value.length == 0) {
                callback(new Error('不可为空'));
            } else {
                callback()
            }
        };
        return {
            roleInfo: {
                comLevel1: true,
                comLevel2: false,
                comLevel3: false,
                comLevel4: false,
                tplRoleId: null,
                tplRoleName: null,
                confName: null,
                realName: null,
                shopFlag: false,
                bizPermFlag: false,
                bizPermOrgFlag: -1,
                bizPermScopId: -1,
                bizPermScopName: ''
            },
            bizUnitTypeMap: getEnumMap("bizUnitType", "value2text"),
            roles: {
                confName: [{validator: validateConfName, trigger: 'blur'}],
                realName: [{validator: validateRealName, trigger: 'blur'}],
                desc: [{validator: validateDesc, trigger: 'blur'}],
                bizPermScopName: [{validator: validateNull, trigger: 'blur'}]
            }
        }
    },
    created: function () {
        let item = this.item;
        if(!Utils.isNoB(item) && item.id != null) {
            this.roleInfo = item;
        }
    },
    methods: {
        tplComRoleDlg() {
            let self = this;
            let theDlg = Vue.$showDialog({
                title: '平台职责权限配置 - 选择',
                width: 1200,
                height: 700,
                showCloseBtn: true,
                template: '<div>' +
                    '<swb-tpl-com-role-list-select :merchantType="merchantType" :radioFlag="true" ref="swb_tpl_com_role_list_select"></swb-tpl-com-role-list-select>' +
                    '</div>',
                data: {
                    merchantType: getEnumInfoWith('merchantType', 'name', 'Retailer').value
                },
                methods: {},
                okClicked: function () {
                    let dlgSelf = this;
                    let result = this.$refs.swb_tpl_com_role_list_select.getDlgResult() || {};
                    if(result.type == 'info') {
                        let roleInfo = self.roleInfo;
                        let tpl = result.data;
                        //
                        roleInfo.tplRoleId = tpl.id;
                        roleInfo.tplRoleName = tpl.confName;
                        roleInfo.confName = tpl.confName;
                        roleInfo.realName = tpl.realName;
                        roleInfo.desc = tpl.desc;
                        self.roleInfo = Utils.merge({}, roleInfo);
                        return true;
                    } else {
                        Toast.show(result.message);
                    }
                    return false;
                }
            });
        },
        bizScopeDlg() {
            let self = this;
            let filter = {};
            let roleInfo = self.roleInfo;
            if(!this.isAdd && Utils.isTrue(roleInfo.bizRefFlag)) {
                filter.shopFlag = roleInfo.shopFlag;
                filter.comLevel1 = roleInfo.comLevel1;
                filter.comLevel2 = roleInfo.comLevel2;
                filter.comLevel3 = roleInfo.comLevel3;
                filter.comLevel4 = roleInfo.comLevel4;
            }
            let theDlg = Vue.$showDialog({
                title: '业务范围 - 选择',
                width: 1200,
                height: 700,
                showCloseBtn: true,
                template: '<swb-mercht-biz-perm-scope-list-select :filter="filter" ref="swb_select"></swb-mercht-biz-perm-scope-list-select>',
                data: {
                    filter: filter
                },
                methods: {},
                okClicked: function () {
                    let result = this.$refs.swb_select.getDlgResult() || {};
                    if(result.type == 'info') {
                        let roleInfo = self.roleInfo;
                        let bizScope = result.data;
                        //
                        roleInfo.bizPermScopId = bizScope.id;
                        roleInfo.bizPermScopName = bizScope.name;
                        roleInfo.shopFlag = bizScope.shopFlag;
                        roleInfo.comLevel1 = bizScope.comLevel1;
                        roleInfo.comLevel2 = bizScope.comLevel2;
                        roleInfo.comLevel3 = bizScope.comLevel3;
                        roleInfo.comLevel4 = bizScope.comLevel4;
                        roleInfo.bizPermFlag = bizScope.bizPermFlag;
                        roleInfo.bizPermOrgFlag = bizScope.bizPermOrgFlag;
                        roleInfo.bizUnitType = bizScope.bizUnitType;
                        self.roleInfo = Utils.merge({}, roleInfo);
                        return true;
                    } else {
                        Toast.show(result.message);
                    }
                    return false;
                }
            });
        },
        getDlgResult: function () {
            // 提供回调函数，返回结果
            let self = this;
            let result = {};
            this.$refs['roleInfo'].validate(function (valid) {
                if(valid) {
                    result.type = 'info';
                    result.data = self.roleInfo;
                } else {
                    result.type = 'warn';
                    result.message = '校验失败';
                }
            });
            return result;
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/compo/authx/MerchtTplRoleSave.vue